import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RouterModule, Routes } from '@angular/router';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ChangePasscodeComponent } from './change-passcode/change-passcode.component';
import { PayTuitionComponent } from './pay-tuition/pay-tuition.component';
import { OtherPaymentsComponent } from './other-payments/other-payments.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { SemesterResultComponent } from './semester-result/semester-result.component';
import { CourseRegistrationComponent } from './course-registration/course-registration.component';
import { RegistrationHistoryComponent } from './registration-history/registration-history.component';
import { ViewTimetableComponent } from './view-timetable/view-timetable.component';
import { DocumentListComponent } from './document-list/document-list.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth.guard';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { LogoutComponent } from './logout/logout.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { StaffEvaluationComponent } from './staff-evaluation/staff-evaluation.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { HelpComponent } from './help/help.component';
import { CBTLayoutComponent } from './cbtlayout/cbtlayout.component';
import { CbtComponent } from './cbt/cbt.component';
import { ExamScoreSummaryComponent } from './exam-score-summary/exam-score-summary.component';
import { ExamDetailsComponent } from './exam-details/exam-details.component';
import { ResourcesComponent } from './resources/resources.component';
import { ElectionComponent } from './election/election.component';
import { WatchResourceComponent } from "./watch-resource/watch-resource.component";
import { NoticeBoardComponent } from './notice-board/notice-board.component';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';
import { AccomodationComponent } from './accomodation/accomodation.component';
import { MultiRoomComponent } from './virtual-class/multi-room/multi-room.component';
import { UserfeedbackComponent } from './virtual-class/userfeedback/userfeedback.component';
import { StudentCertificateComponent } from './student-certificate/student-certificate.component';
import { TermReportSheetsComponent } from './term-report-sheets/term-report-sheets.component';
import { WeightedReportSheetsComponent } from './weighted-report-sheets/weighted-report-sheets.component';
import { MaintenanceGuard } from './maintenance.guard';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { ReverseMaintenanceGuard } from './reverse-maintenance.guard';


const routes: Routes = [
  { path: "", redirectTo: "/home/dashboard", pathMatch: "full" },
  {
    path: "login",
    component: LoginLayoutComponent,
    children: [{ path: "", component: LoginComponent, canActivate: [MaintenanceGuard] }]
  },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "reset-password", component: ResetPasswordComponent },
  {
    path: "maintenance",
    component: MaintenanceComponent,
    canActivate: [ReverseMaintenanceGuard]


  },
  {
    path: "home",
    component: HomeLayoutComponent,
    canActivate: [AuthGuard, MaintenanceGuard],
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      { path: "dashboard", component: DashboardComponent },
      { path: "virtual-class", component: MultiRoomComponent },
      { path: "userfeedback", component: UserfeedbackComponent },
      { path: "my-profile", component: MyProfileComponent },
      { path: "change-passcode", component: ChangePasscodeComponent },
      { path: "document-list", component: DocumentListComponent },
      { path: "pay-tuition", component: PayTuitionComponent },
      { path: "other-payments", component: OtherPaymentsComponent },
      { path: "payment-history", component: PaymentHistoryComponent },
      { path: "transaction-history", component: TransactionHistoryComponent },
      { path: "semester-result", component: SemesterResultComponent },
      { path: "course-registration", component: CourseRegistrationComponent },
      { path: "accomodation", component: AccomodationComponent },
      { path: "resources", component: ResourcesComponent },

      { path: "registration-history", component: RegistrationHistoryComponent },
      { path: "view-timetable", component: ViewTimetableComponent },
      { path: "logout", component: LogoutComponent },
      // { path: "vid-resource", component: VideoResourceComponent},
      { path: "watch-resource", component: WatchResourceComponent },
      {
        path: "staff-evaluation/:sub_id/:co_id/:r_id",
        component: StaffEvaluationComponent
      },
      { path: "notifications", component: NotificationsComponent },
      { path: "election", component: ElectionComponent },
      { path: "help", component: HelpComponent },
      { path: "notice-board", component: NoticeBoardComponent },
      { path: "certificate", component: StudentCertificateComponent },
      { path: "term-report-sheets", component: TermReportSheetsComponent },
      { path: "weighted-report-sheets/:session_id", component: WeightedReportSheetsComponent },
      { path: "weighted-report-sheets", component: WeightedReportSheetsComponent }
    ]
  },
  {
    path: "cbt",
    component: CBTLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "exam", component: CbtComponent },
      { path: "exam-summary", component: ExamScoreSummaryComponent },
      { path: "exam-details", component: ExamDetailsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }